<!-- @format -->

<ng-container *transloco="let t">
  <div class="modal-header">
    <h2 class="modal-title">
      {{ t(values.title) }}
    </h2>
    <button type="button" class="modal-close" (click)="modalInstance.close()" [attr.aria-label]="t('ARIA_LABEL.CLOSE')">
      <sis-icon icon="ring-close"></sis-icon>
    </button>
  </div>
  <div class="modal-body">
    @if (values.completePaymentMsgAnchorElement) {
      <p>
        <sis-markup-string-view (click)="modalInstance.close()" [content]="values.completePaymentMsgAnchorElement" />
      </p>
    }
    @for (description of values.descriptions; track description) {
      <p>
        {{ t(description) }}
      </p>
    }
    <p>
      @if (values.orderNumberMsg) {
        <sis-markup-string-view [content]="values.orderNumberMsg" />
      }
    </p>
    @if (values.contactOrganizer) {
      <div class="row">
        <span>{{ t(values.contactOrganizer.msg) }}</span>
        @if (values.contactOrganizer.link) {
          <span>
            <a
              fudisLink
              [href]="values.contactOrganizer.link"
              [external]="true"
              [title]="removeMailtoFromName(values.contactOrganizer.link)"></a>
          </span>
        }
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-lg" (click)="modalInstance.close()">
      {{ t("BUTTON.CLOSE") }}
    </button>
  </div>
</ng-container>
